// src/utils/parseWhatsAppMessage.js
import React from "react";

const urlRegex =
  /(https?:\/\/[^\s]+|www\.[^\s]+)/gi;

export function parseWhatsAppMessage(text) {
  const parts = [];
  let lastIndex = 0;

  // Detectar URLs primero
  text.replace(urlRegex, (match, _, index) => {
    if (index > lastIndex) {
      parts.push(...formatText(text.slice(lastIndex, index)));
    }

    const href = match.startsWith("http")
      ? match
      : `https://${match}`;

    parts.push(
      <a
        key={`link-${index}`}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="wa-link"
      >
        {match}
      </a>
    );

    lastIndex = index + match.length;
  });

  if (lastIndex < text.length) {
    parts.push(...formatText(text.slice(lastIndex)));
  }

  return parts;
}

function formatText(text) {
  const tokens = [];
  let buffer = "";
  let stack = [];

  const flush = () => {
    if (buffer) {
      tokens.push(buffer);
      buffer = "";
    }
  };

  for (let i = 0; i < text.length; i++) {
    const c = text[i];

    if (["*", "_", "~"].includes(c)) {
      const idx = stack.lastIndexOf(c);

      if (idx !== -1) {
        flush();
        const content = stack.slice(idx + 1).join("") + buffer;
        stack = stack.slice(0, idx);
        buffer = "";

        const Tag =
          c === "*"
            ? "strong"
            : c === "_"
            ? "em"
            : "del";

        tokens.push(<Tag key={tokens.length}>{content}</Tag>);
      } else {
        flush();
        stack.push(c);
      }
    } else if (c === "\n") {
      flush();
      tokens.push(<br key={tokens.length} />);
    } else {
      buffer += c;
    }
  }

  flush();
  return tokens;
}
